export default "__VITE_ASSET__g8Cep0yx__"